const ENDPOINT = "https://api.web3forms.com/submit";

export async function submitToWeb3Forms(formEl, { subject, fromName }) {
  const data = new FormData(formEl);
  data.append("access_key", process.env.REACT_APP_WEB3FORMS_KEY);
  data.append("subject", subject);
  data.append("from_name", fromName);

  const res = await fetch(ENDPOINT, {
    method: "POST",
    headers: { Accept: "application/json" },
    body: data,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || "Submission failed. Please try again.");
  }
  return json;
}
